import type { EtapaPipeline } from './types'

/**
 * Las etapas del tablero, en orden, con el nombre que se lee en pantalla.
 *
 * `prospecto` queda fuera: es outbound que todavía no se contactó y vive en
 * su propia pantalla, no en el tablero.
 *
 * Son del sistema y no se configuran. Lo que cada partner arma son los pasos
 * DENTRO de una de estas (`pipeline_subestados`): el cotizador, los bots y
 * los reportes actúan sobre la etapa, así que si cada quien inventara las
 * suyas nada de eso sabría qué hacer, y dos carteras dejarían de compararse.
 */
export const ETAPAS_TABLERO: { key: EtapaPipeline; label: string }[] = [
  { key: 'lead', label: 'Lead' },
  { key: 'contactado', label: 'Contactado' },
  { key: 'diagnostico', label: 'Diagnóstico' },
  { key: 'cotizado', label: 'Cotizado' },
  { key: 'negociacion', label: 'Negociación' },
  { key: 'cerrado', label: 'Cerrado' },
]

export function etiquetaDeEtapa(etapa: string): string {
  return ETAPAS_TABLERO.find(e => e.key === etapa)?.label
    ?? (etapa === 'prospecto' ? 'Prospecto' : etapa)
}
